import {useState, useEffect} from 'react';
import styles from './style.module.scss';
import {faDownload} from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  Button,
} from '@/components/common-components/components';
import {CopyOutlined} from '@ant-design/icons';

import {Divider, Tooltip} from 'antd';
import {faCheck} from '@fortawesome/pro-regular-svg-icons';
import {SCA_PAGE_CONTENT_IDEA_COPY, SCA_PAGE_CONTENT_IDEA_DOWNLOAD} from '@/constants/events';

import {MixPanel} from '@/utils/mixpanel';
import {useTranslation} from 'next-i18next';
import parse from 'html-react-parser';

interface Props {
  idea: string;
}

export const SingleContentIdea = ({idea}: Props) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [convertedText, setConvertedText] = useState(idea);

  const {t} = useTranslation('landing-page-optimizer');

  useEffect(() => {
    // Removing the leading space from string
    const newLineIndex = idea?.search('\n');
    const textWithoutLeadingSpace = idea?.slice(0, newLineIndex + 1) + idea?.slice(newLineIndex + 2);
    const firstTitle = idea?.slice(0, newLineIndex + 1);
    const result = textWithoutLeadingSpace.replace(firstTitle, '<span>' + firstTitle + '</span>');

    setConvertedText(result);
  }, [idea]);


  const downloadFileToTxt = () => {
    const element = document.createElement('a');
    const file = new Blob([idea], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    const breakFileName = idea.split(' ').length;
    const fileName = breakFileName > 4 ? idea.split(' ').slice(0, 4).join('-') : idea.split(' ').slice(0, breakFileName).join('-');
    element.download = `${fileName}`;
    document.body.appendChild(element);
    element.click();
  };

  return (
    <div className={styles.ContentIdeaContainer}>
      <p className={styles.ContentIdea}>
        {convertedText && parse(convertedText.trim())}
      </p>
      <Divider className={styles.popoverDivider} />
      <div style={{display: 'flex', justifyContent: 'space-between', cursor: 'default'}}>
        <span>{`${idea.replace(/(\r\n|\n|\r)/gm, '').length} characters`}</span>
        <div className={styles.controlButtons}>
          <FontAwesomeIcon icon={faDownload} className={styles.downloadButton} onClick={() => {
            downloadFileToTxt();

            MixPanel.track(SCA_PAGE_CONTENT_IDEA_DOWNLOAD, {
              'description': 'Content idea downloaded',
            });
          }}/>
          <Tooltip
            title={copySuccess ? <span><FontAwesomeIcon icon={faCheck} style={{color: '#2AC155'}}/>{` Copied to clipboard`}</span> : t('copy-to-clipboard')}
            trigger='hover'
            placement='bottom'
            overlayClassName={styles.copyTooltip}
            onVisibleChange={visible => {
              if (!visible) {
                setTimeout(() => {
                  setCopySuccess(false);
                }, 300);
              }
            }}>
            <Button
              type='submit'
              buttonType='purple-opaque'
              className={styles.copyButton}
              onClick={() => {
                navigator.clipboard.writeText(idea);
                setCopySuccess(true);

                MixPanel.track(SCA_PAGE_CONTENT_IDEA_COPY, {
                  'description': 'Content idea copied',
                });
              }}>
              <span>
                <CopyOutlined style={{marginRight: '5px'}}/>
                Copy
              </span>
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
